import axios from "../core/https";
import { IBuyerLicense, ISellerLicense, IUser } from "../core/models/user";

const updateProfile = (body: IUser) => axios.post("/accounts/profile", body);

const getProfile = () => axios.get<IUser>("/accounts/profile");
const getProfileById = (id: string) =>
  axios.get<IUser>(`/accounts/${id.toLowerCase()}`, {
    headers: {
      requireToken: "0",
    },
  });

const watch = (id: string) =>
  axios.post(
    `/accounts/${id.toLowerCase()}/watch`,
    {},
    {
      headers: {
        requireToken: "0",
      },
    }
  );

const submitSellerDoc = () => axios.post<IUser>("/accounts/submit-seller-doc");
const submitCreditDoc = () => axios.post<IUser>("/accounts/submit-credit-doc");

const getBuyerLicense = () => axios.get<{ signature: string; license: IBuyerLicense }>("/accounts/get-buyer-license");
const getSellerLicense = () =>
  axios.get<{ signature: string; license: ISellerLicense }>("/accounts/get-seller-license");

export const userService = {
  updateProfile,
  getProfile,
  submitSellerDoc,
  submitCreditDoc,
  getProfileById,
  watch,
  getBuyerLicense,
  getSellerLicense,
};
